var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeShow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 18C6.73664 18 2.28304 12.9821 0.618557 10.8338C-0.206186 9.77494 -0.206186 8.24041 0.618557 7.18159C2.28304 5.0179 6.73664 0 12 0C17.2634 0 21.717 5.0179 23.3814 7.16624C24.2062 8.22506 24.2062 9.75959 23.3814 10.8184C21.717 12.9821 17.2783 18 12 18ZM3.0328 8.99233C4.20244 10.4962 8.01124 14.9309 12 14.9309C15.9888 14.9309 19.7976 10.4962 20.9672 9.00767C19.7976 7.50384 15.9888 3.06905 12 3.06905C8.01124 3.06905 4.20244 7.50384 3.0328 8.99233Z",
    fill: "#B33939"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 13.8262C9.4057 13.8262 7.27637 11.6625 7.27637 8.99245C7.27637 6.32237 9.39071 4.15869 11.9999 4.15869C14.5941 4.15869 16.7234 6.32237 16.7234 8.99245C16.7234 11.6625 14.6091 13.8262 11.9999 13.8262ZM11.9999 7.24309C11.0552 7.24309 10.2754 8.0257 10.2754 9.0078C10.2754 9.98989 11.0552 10.7572 11.9999 10.7572C12.9446 10.7572 13.7244 9.97455 13.7244 8.99245C13.7244 8.01035 12.9446 7.24309 11.9999 7.24309Z",
    fill: "#B33939"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeShow);
export default __webpack_public_path__ + "static/media/eye-show.8286c997.svg";
export { ForwardRef as ReactComponent };